import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from './env';

/**
 * Browser Supabase client. Uses the anon key — RLS enforces every read/write.
 * Never instantiate the service-role client in the web app.
 */
export const supabase: SupabaseClient = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storageKey: 'clinio-communicate-auth',
  },
  global: {
    headers: {
      'x-application-name': 'clinio-communicate-web',
    },
  },
});
